import { api } from "../../../interceptores/instancias";
import { ILogin, IUsuarioRolContexto, IRespuestaContexto } from "../model/modelAuth";

/**
 * Autentica al usuario y devuelve los contextos
 * a los que tiene acceso.
 */
export const WSLogin = async (credentials: ILogin): Promise<IUsuarioRolContexto[]> => {
  const response = await api.post<IUsuarioRolContexto[]>("/auth/login",credentials);
  return response.data;
};

/**
 * Cierra la sesión actual en el servidor.
 */
export const WSLogout = async (): Promise<void> => {
  await api.post("/auth/logout",null,{withCredentials: true,});
};

/**
 * Selecciona uno de los contextos disponibles para el usuario
 * y devuelve la información completa de la sesión.
 */
export const WSContextSelection = async (contextoId: number): Promise<IRespuestaContexto> => {
  const response = await api.post<IRespuestaContexto>("/auth/seleccionar-contexto",{contextoId},{withCredentials: true});
  return response.data;
};